import React from 'react';
import './App.css';
import Camera from './components/Camera';

function App() {
  return (
    <div className="App">
      <h1>React Camera App</h1>
      <Camera />
    </div>
  );
}

export default App;